import { MedusaProductVariant, SubscriptionProductsQuery } from 'lib/home/generated/types/api';
import { SelectPlanFormValues } from '.';
import { MealPlansInputGroup } from '../..';

export const generateTabs = (values: SelectPlanFormValues, subscriptionProducts: SubscriptionProductsQuery) =>
  Object.entries(subscriptionProducts).reduce((prev, [key, products]: [string, MedusaProductVariant[]]) => {
    const label = key.split('Subscriptions')[0];
    const render = (
      <MealPlansInputGroup
        name="selectedPlan"
        plans={products.sort((a, b) => (a.sku < b.sku ? -1 : 1))}
        values={values}
      />
    );

    return [...prev, { label, render }];
  }, []);
